import {
  Box,
  BoxProps,
  CircularProgress,
  Dialog,
  Theme,
  withStyles,
} from '@material-ui/core';
import React from 'react';
import MuiDialogContent from '@material-ui/core/DialogContent/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions/DialogActions';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';

export const BankLabel = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[400],
  },
}))(FsBodySmall);

export const BankLabelWrapperBox = withStyles(({ spacing }: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing(1),
  },
}))((props: BoxProps) => <Box {...props} />);

export const ContentWrapperBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    [breakpoints.up('md')]: {
      minWidth: 630,
    },
  },
}))(Box);

export const AbsoluteCircularProgress = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
  },
}))(CircularProgress);

export const RelativeSendButtonWrapperBox = withStyles(() => ({
  root: {
    position: 'relative',
  },
}))(Box);

export const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export const CustomDialog = withStyles(() => ({
  root: {},
}))(Dialog);
